import Joi from 'joi';

/**
 * Checks that an account search names exactly one account.
 */
export const accountsSearchFiltersSchema = () =>
  Joi.object({
    handle: Joi.string().trim().min(1).messages({
      'string.base': 'validations|account-handle|must-be-string',
      'string.min': 'validations|account-handle|required',
    }),
    handleQrCode: Joi.string().trim().min(1).messages({
      'string.base': 'validations|account-handle-qr-code|must-be-string',
      'string.min': 'validations|account-handle-qr-code|required',
    }),
    uuid: Joi.string().trim().guid({ version: 'uuidv4' }).messages({
      'string.base': 'validations|account-uuid|must-be-string',
      'string.guid': 'validations|account-uuid|must-be-uuid',
    }),
  })
    .xor('handle', 'handleQrCode', 'uuid')
    .messages({
      'object.xor': 'validations|account-search|handle-or-qr-code',
      'object.missing': 'validations|account-search|handle-or-qr-code',
    });
